import { useMutation } from 'react-query';
import TradeService from '../../../services/TradeService';

const useFetchAuctionSummary = () => {
  const tradeService = TradeService.get();
  const fetchAuctionSummary = useMutation(async (tradeId: number) => {
    try {
      const data = await tradeService.getAssociatedTradeDetails(tradeId, [
        'auctionSummary'
      ]);
      return data?.auctionSummary;
    } catch (e) {
      return null;
    }
  });
  return fetchAuctionSummary.mutateAsync;
};

export default useFetchAuctionSummary;
